"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Types_1 = require("../../Types");
var core_1 = require("@athena-portal/core");
var react_router_dom_1 = require("react-router-dom");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var services_1 = require("@falcon/services");
var ShowAllCardsAction_1 = require("./actions/ShowAllCardsAction");
var Checkbox_1 = require("../../components/Checkbox");
var PaymentsHeader = /** @class */ (function (_super) {
    __extends(PaymentsHeader, _super);
    function PaymentsHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.templates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.getOrdinal = function (num) {
            var suffixes = ["th", "st", "nd", "rd"];
            var numberEnding = num % 100;
            return num + (suffixes[(numberEnding - 20) % 10] || suffixes[numberEnding] || suffixes[0]);
        };
        _this.state = {
            interaction: null,
            policyVersion: null,
            creditCard: null,
            interactionLoaded: false,
            automaticRenewal: "",
            premiumType: "",
            paymentType: "",
            reuseCard: false
        };
        return _this;
    }
    PaymentsHeader.prototype.componentDidMount = function () {
        var _this = this;
        this.supportPortalService
            .getPolicyVersionDetails(this.props.userId, this.props.policyNumber, this.props.version)
            .subscribe(function (policyVersion) {
            _this.setState({ policyVersion: policyVersion });
            _this.supportPortalService.getInteraction(policyVersion.interactionId).subscribe(function (interaction) {
                _this.setState({ interaction: interaction, interactionLoaded: true });
            });
        });
        this.supportPortalService.getPolicyPropertiesByPropertyKeys(this.props.policyNumber, [services_1.PolicyPropertyEnum.MAIN_ANNUAL_PAYMENT_CARD, "modifiedPaymentDay", services_1.PolicyPropertyEnum.AUTOMATIC_RENEWAL, services_1.PolicyPropertyEnum.REUSE_MAIN_CARD])
            .subscribe(function (properties) {
            properties.forEach(function (property) {
                if (property.key === services_1.PolicyPropertyEnum.MAIN_ANNUAL_PAYMENT_CARD) {
                    _this.supportPortalService
                        .getCreditCard(property.value)
                        .subscribe(function (creditCard) {
                        _this.setState({ creditCard: creditCard });
                    });
                }
                else if (property.key === "modifiedPaymentDay") {
                    _this.setState({ paymentDay: property.value });
                }
                else if (property.key === services_1.PolicyPropertyEnum.AUTOMATIC_RENEWAL) {
                    _this.setState({ automaticRenewal: property.value === "true" ? "Yes" : "No" });
                }
                else if (property.key === services_1.PolicyPropertyEnum.REUSE_MAIN_CARD) {
                    _this.setState({ reuseCard: property.value === "true" });
                }
            });
        });
        this.supportPortalService.getPolicyVersionPropertiesByPropertyKeys(this.props.policyNumber, ["premiumType", "paymentType"]).subscribe(function (properties) {
            properties.forEach(function (property) {
                if (property.key === "premiumType") {
                    _this.setState({ premiumType: property.value });
                }
                else if (property.key === "paymentType") {
                    _this.setState({ paymentType: property.value });
                }
            });
        });
    };
    PaymentsHeader.prototype.render = function () {
        var _a;
        if (!this.state.interactionLoaded || !this.state.creditCard) {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
        else {
            var paymentMethod = this.getPaymentMethod();
            var creditCardExpirationDate = new Date(2000 + this.state.creditCard.expiryYear, this.state.creditCard.expiryMonth);
            var isCreditCardExpired = new Date() >= creditCardExpirationDate;
            return ((0, jsx_runtime_1.jsx)("div", { className: "panel-border px-4", children: (0, jsx_runtime_1.jsxs)("div", { className: "row py-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "col-5 font-weight-bold", children: "Payment Method:" }), (0, jsx_runtime_1.jsx)("div", { className: "col-7", children: paymentMethod }), (0, jsx_runtime_1.jsx)("div", { className: "col-5 py-3 font-weight-bold", children: "Card Registered on account:" }), (0, jsx_runtime_1.jsxs)("div", { className: "col-7 py-3", children: [this.state.creditCard.cardNumberObfuscated, (0, jsx_runtime_1.jsxs)("span", { className: "ml-2 ".concat(isCreditCardExpired ? "text-danger" : ""), children: ["(", String(this.state.creditCard.expiryMonth).padStart(2, '0'), "/", this.state.creditCard.expiryYear, ")"] }), (0, jsx_runtime_1.jsx)(ShowAllCardsAction_1.default, { customerId: this.props.userId })] }), (0, jsx_runtime_1.jsx)("div", { className: "col-5 py-3 font-weight-bold", children: "MTA permission to use payment card:" }), (0, jsx_runtime_1.jsx)("div", { className: "col-7 py-3", children: (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "reuseCardCheckbox", className: "no-label", name: "reuse-card", label: "", disabled: true, value: this.state.reuseCard, onChanged: function () { } }) }), (0, jsx_runtime_1.jsx)("div", { className: "col-5 pb-3 font-weight-bold", children: "Automatic Renewal:" }), (0, jsx_runtime_1.jsx)("div", { className: "col-7 pb-3", children: this.state.automaticRenewal }), (0, jsx_runtime_1.jsx)("div", { className: "col-5 pb-3 font-weight-bold", children: "Payment Date:" }), (0, jsx_runtime_1.jsx)("div", { className: "col-7", children: paymentMethod === "monthly" ? this.getPaymentDay() : "N/A" }), ((_a = this.state.interaction) === null || _a === void 0 ? void 0 : _a.product) !== services_1.ProductsEnum.HOME && this.renderCorrectiveMeasuresLink()] }) }));
        }
    };
    PaymentsHeader.prototype.getPaymentMethod = function () {
        var paymentType = this.state.premiumType && this.state.paymentType === "directDebit" ? "direct debit" : "card";
        var premiumType = this.state.premiumType ? this.state.premiumType : this.state.interaction.factors.premiumType;
        return "".concat(premiumType, " ").concat(paymentType);
    };
    PaymentsHeader.prototype.renderCorrectiveMeasuresLink = function () {
        if (this.templates.userHasRole(["Administrator"])) {
            return (0, jsx_runtime_1.jsx)("div", { className: "col-12", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/customers/".concat(this.props.userId, "/invoiceCorrectiveMeasures/").concat(this.props.policyNumber, "?name=").concat(this.props.firstName, "&lastname=").concat(this.props.lastName), children: "Corrective measures" }) });
        }
        else {
            return;
        }
    };
    PaymentsHeader.prototype.getPaymentDay = function () {
        var paymentDay = this.state.interaction.paymentDay.day;
        if (this.state.paymentDay) {
            paymentDay = this.state.paymentDay;
        }
        paymentDay = this.getOrdinal(parseInt(paymentDay, 10));
        return paymentDay;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], PaymentsHeader.prototype, "supportPortalService", void 0);
    PaymentsHeader = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], PaymentsHeader);
    return PaymentsHeader;
}(React.Component));
exports.default = PaymentsHeader;
//# sourceMappingURL=PaymentsHeader.js.map